module.exports = __webpack_public_path__ + "img/AF.9bdab7d7.png";